import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { discoverRouteDefinition } from '@townsquare/routes/discover';

import { farewellFeedResource } from './resources/farewell-feed-resource';
import { loomFeedResource } from './resources/loom-feed-resource';
import { popularFeedResource } from './resources/popular-feed-resource';
import { welcomeFeedResource } from './resources/welcome-feed-resource';

discoverRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "discover-view" */ './components/DiscoverView'),
	loading: () => null,
});

discoverRouteDefinition.header = Loadable({
	loader: () => import(/* webpackChunkName: "discover-header" */ './components/DiscoverHeader'),
	loading: SkeletonWithoutBreadcrumbs,
});

discoverRouteDefinition.resources = [
	loomFeedResource,
	popularFeedResource,
	welcomeFeedResource,
	farewellFeedResource,
];

export const discoverRoute: GlobalHomePageRoute = discoverRouteDefinition;
